import React from 'react';
import './Hero.css';

// Assets
import memeDoggy from '../../assets/logos/meme_doggy.jpeg';

/**
 * SECCIÓN 1: HERO
 * Diseño EXACTO de la imagen de referencia
 */
const Hero = () => {
  return (
    <section className="hero" id="hero">
      {/* Texto principal arriba */}
      <h1 className="hero__title">
        <span>Mexicanos crean</span>
        <span>criptomoneda</span>
      </h1>

      {/* Meme DOGGY - debajo del título */}
      <img 
        src={memeDoggy} 
        alt="DOGGY Bimsness" 
        className="hero__mascot"
      />

      {/* Frase descriptiva - debajo del meme */}
      <p className="hero__subtitle">
        <span className="hero__subtitle-line">y ayudan a cientos de</span>
        <span className="hero__subtitle-line">perros y niños en el camino</span>
      </p>

      {/* Scroll indicator */}
      <div className="hero__scroll" onClick={() => document.getElementById('impacto')?.scrollIntoView({ behavior: 'smooth' })}>
        <span>Conoce nuestro impacto</span>
        <svg className="hero__scroll-arrow" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 14.975l-4.95-4.95 1.414-1.414L12 12.147l3.536-3.536 1.414 1.414z"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
